module.exports = __webpack_public_path__ + "loading.gif?a6178f443133606fe19006604d0cafb5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.gif
// module id = 312
// module chunks = 2